import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Icon } from '@codex-brightworld/icons';

const Panel = styled.div`
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.neutral.grey[2]}`};
  @media ${({ theme }) => `${theme.breakpoints.tabletMin}`} {
    display: flex;
    border-bottom: none;
  }
`;

const Bar = styled.div`
  cursor: pointer;
  transform: translate3d(0, 0, 0);
  transition: background 0.2s;
  ${({ active }) => css`
    padding: ${active ? '20px 0 0' : '20px 0 20px'};
  `}

  ${Icon} {
    float: right;
    width: 24px;
    height: 24px;
    margin-top: -2px;
    transition: all 0.2s;
    ${({ active }) => css`
      transform: rotate(${active ? 270 : 90}deg);
    `};
  }

  @media ${({ theme }) => `${theme.breakpoints.tabletMin}`} {
    display: inline-block;
    padding: 0;

    ${Icon} {
      display: none;
    }
  }
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: bold;

  @media ${({ theme }) => `${theme.breakpoints.tabletMin}`} {
    margin-top: 13px;
  }

  @media ${({ theme }) => `${theme.breakpoints.desktop}`} {
    display: none;
  }
`;

const ContentSection = styled.div`
  ${({ active }) => css`
    display: ${active ? 'block' : 'none'};
  `};

  @media ${({ theme }) => `${theme.breakpoints.tabletMin}`} {
    display: inline-block;
  }
`;

const AccordionPanel = (props) => {
  const { title, ...rest } = props;
  const panelRef = React.createRef();
  const [active, setActive] = React.useState(props.active);

  const onClickHandler = () => {
    setActive(!active);
  };

  return (
    <Panel {...rest} ref={panelRef} data-qa={props.qa}>
      <Bar active={active} onClick={onClickHandler}>
        <Icon icon="arrowright" />
        <Title>{title}</Title>
      </Bar>
      <ContentSection active={active}>
        <div>{props.children}</div>
      </ContentSection>
    </Panel>
  );
};

AccordionPanel.displayName = 'AccordionPanel';

AccordionPanel.propTypes = {
  panelId: PropTypes.number.isRequired,
  active: PropTypes.bool,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  scrollOffset: PropTypes.number.isRequired,
  qa: PropTypes.string
};

AccordionPanel.defaultProps = {
  active: false,
  qa: undefined
};

/** @component */
export default AccordionPanel;
